module.exports = __webpack_public_path__ + "static/media/logo-07.95eee159.svg";